// extracted by extract-css-chunks-webpack-plugin
module.exports = {"rounded-corners":"Auth__rounded-corners___2AFXc","bordered":"Auth__bordered___2BMKq","outer":"Auth__outer___2kSDF","inner":"Auth__inner___sRk2e","alt":"Auth__alt___35sKw"};
    if(module.hot) {
      // 1778083489712
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  